import brixigoLogo from "../assets/images/brixigo-b-logo.png";
import "../../styles/brixigoPageLoader.css";

/**
 * Brixigo branded loader — logo with orbiting rings.
 * @param {string} message - Optional status text below the logo
 * @param {boolean} fullPage - Min-height for in-page loading blocks
 * @param {boolean} overlay - Fixed fullscreen overlay (route transitions)
 * @param {boolean} compact - Smaller variant for tabs, charts, and panels
 */
export default function BrixigoPageLoader({
  message = "Loading…",
  fullPage = true,
  overlay = false,
  compact = false,
}) {
  const cls = [
    "bpl-root",
    fullPage ? "bpl-full" : "",
    overlay ? "bpl-overlay" : "",
    compact ? "bpl-compact" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={cls} role="status" aria-live="polite" aria-busy="true">
      <div className="bpl-orbit-wrap">
        <div className="bpl-ring bpl-ring-1" aria-hidden />
        <div className="bpl-ring bpl-ring-2" aria-hidden />
        <div className="bpl-ring bpl-ring-3" aria-hidden />
        <img src={brixigoLogo} alt="Brixigo" className="bpl-logo" draggable={false} />
      </div>
      {message ? <p className="bpl-msg">{message}</p> : null}
    </div>
  );
}
